/* Our Story chapters: tap right to go on, left to go back, swipe sideways, swipe down or close to reach the shop. */
(function () {
  const st = document.getElementById('st');
  if (!st) return;
  const frame = st.querySelector('.st__frame');
  const slides = Array.from(st.querySelectorAll('.st__slide'));
  const bars = Array.from(st.querySelectorAll('.st__bars span'));
  if (!slides.length) return;
  let i = 0, sx = 0, sy = 0, swiped = false;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function go(n) {
    i = Math.max(0, Math.min(slides.length - 1, n));
    slides.forEach((s, k) => {
      const on = k === i;
      s.classList.toggle('is-on', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      const v = s.querySelector('video');
      if (v) { if (on) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause(); }
    });
    bars.forEach((b, k) => b.classList.toggle('is-done', k <= i));
    const cur = slides[i];
    st.dataset.tone = cur.classList.contains('st__slide--collage') || cur.classList.contains('st--paper') ? 'light' : 'dark';
  }
  function close() {
    slides.forEach((s) => { const v = s.querySelector('video'); if (v) v.pause(); });
    st.classList.add('is-closed');
    document.documentElement.classList.remove('st-open');
    try { history.replaceState(null, '', root); } catch (e) {}
    window.scrollTo(0, 0);
  }
  function isHome(a) { try { return new URL(a.href, location.href).pathname === root; } catch (e) { return false; } }

  st.classList.add('is-ready');
  document.documentElement.classList.add('st-open');
  go(0);

  frame.addEventListener('click', (e) => {
    if (swiped) { swiped = false; return; }
    const a = e.target.closest('a');
    if (a) { if (a.id === 'stClose' || (a.hasAttribute('data-st-close') && isHome(a))) { e.preventDefault(); close(); } return; }
    const t = e.target.closest('.st__tap');
    if (t) { go(i + (t.classList.contains('st__tap--prev') ? -1 : 1)); return; }
    const r = frame.getBoundingClientRect();
    go(i + (e.clientX - r.left < r.width * 0.3 ? -1 : 1));
  });
  frame.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  frame.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(i + (dx < 0 ? 1 : -1)); }
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { swiped = true; close(); }
    if (swiped) setTimeout(() => { swiped = false; }, 400);
  });
  document.addEventListener('keydown', (e) => {
    if (st.classList.contains('is-closed')) return;
    if (e.key === 'ArrowRight') go(i + 1);
    else if (e.key === 'ArrowLeft') go(i - 1);
    else if (e.key === 'Escape') close();
  });
})();
